export default __webpack_public_path__ + "static/media/logo_with_font.6ebdc0bc.png";